<template>
    <div class="tabbar flex">
        <p class="money">总计:<span>¥</span><span>{{ props.sum }}</span></p>
        <div class="tabbar-btn">
            <p @click="handleJiesuan">结算<span>({{ props.total }})</span></p>
        </div>
    </div>
</template>
<script setup>
// import {showToast} from "vant";
import {defineProps} from "vue";

const props = defineProps({
    sum: {
        type: Number,
        default: 0
    },
    total: {
        type: Number,
        default: 0
    },
    fn: {
        type: Function,
        default: () =>{}
    },
    type: {
        type: Number,
        default: 1
    },
    active: {
        type: Number,
        default: 0
    }
})

const handleJiesuan = () => {
    props.fn()
    // if(props.type === 2 && props.active !== 0) {
    //     showToast("购物不支持自提和定制配送")
    //     return
    // } else {
    //     props.fn()
    // }
}
</script>
<style scoped lang="scss">
.tabbar {
    position: fixed;
    height: 17.0667vw;
    padding: 0 4vw;
    bottom: 0;
    left: 0;
    right: 0;
    background: #FFFFFF;
    box-shadow: 0px -1px 20px 0px rgba(0,0,0,0.08);
    justify-content: flex-end;
}
.money {
    margin-right: 5.3333vw;
    color: #333333;
    font-size: 14px;
    span {
        color: #FF0000;
        &:last-child {
            font-size: 24px;
        }
    }
}
.tabbar-btn {
    width: 23.2vw;
    height: 10.6667vw;
    line-height: 10.6667vw;
    background: #E30000;
    border-radius: 5.6vw;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    letter-spacing: 1px;
    span {
        font-size: 10px;
    }
}
</style>